module.exports = __webpack_public_path__ + "roboto-medium-webfont.288a02b948bcce5e508e.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-medium-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-medium-webfont.svg
// module chunks = styles